<template>
  <AuthWrapper>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical">
        <sdHeading as="h3">2FA Authenticator</sdHeading>
        <p class="forgot-text">Enter your auth code</p>
        <a-form-item label="Code" name="code">
          <a-input type="text" v-model:value="formState.code" />
        </a-form-item>
        {{ musteriAdi }}
        <a-form-item>
          <sdButton class="btn-reset" htmlType="submit" type="primary" size="large">
            {{ isLoading ? 'Loading...' : 'Submit' }}
          </sdButton>
        </a-form-item>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { mapGetters } from 'vuex';
import { AuthWrapper } from './style';

export default {
  name: 'Test',
  components: { AuthWrapper },
  data() {
    return {
      formState: {
        code: '',
      },
      isLoading: false,
    };
  },
  methods: {
    handleSubmit() {
      // alert(test.param);
    },
  },
  created() {
  },
  computed: {
    ...mapGetters({
      musteriAdi: 'test/_param',
    }),
  },
};
</script>
